import styled from '@emotion/styled';

const modalTitle = styled('h1')({
  fontSize: '2.2rem',
  textAlign: 'center',
});

export default modalTitle;
